import script from "./DeleteUserButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteUserButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__